import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Img from "../../../images/case-studies/mdrouz/logo.png";
import Img1 from "../../../images/case-studies/mdrouz/googleplay.png";
import Img2 from "../../../images/case-studies/mdrouz/appstore.png";
import BgImg from "../../../images/case-studies/mdrouz/banner_back_img.png";
import { Link } from "gatsby";

const banner = () => {
  return (
    <div
      className="case_study_banner"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={5} xl={5} xxl={5} className="my-auto">
            <LazyLoadImage
              src={Img}
              effect="blur"
              alt="TekRevol"
              className="img-fluid logo_img"
            />
            <h1>
              Project
              <br /> <span>Description</span>
            </h1>
            <p>
              Mdrouz is a cutting-edge multi-vendor e-commerce mobile
              application developed by TekRevol for the GCC region, specifically
              targeting consumers interested in purchasing clothing articles
              such as burqas and abayas. The primary objective was to create a
              seamless and visually appealing platform with an emphasis on
              user-friendly interfaces, secure transactions, and personalized
              experiences. One of the key challenges faced during the
              development process was the integration of a local payment
              merchant, Upayment, catering to the specific needs of the Kuwait
              market.
            </p>
            <div class="banner_playbtn">
              <Link to="https://play.google.com/store/apps/details?id=com.mdrouz.app">
                <LazyLoadImage
                  src={Img1}
                  effect="blur"
                  alt="TekRevol"
                  className="img-fluid"
                />
              </Link>
              <Link to="https://apps.apple.com/us/app/%D9%85%D8%AF%D8%B1%D9%88%D8%B2-mdrouz/id6474200224">
                <LazyLoadImage
                  src={Img2}
                  effect="blur"
                  alt="TekRevol"
                  className="img-fluid app_store_btn"
                />
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default banner;
